import { render } from "./TestimonialItemComponent.vue?vue&type=template&id=498c13b9"
import script from "./TestimonialItemComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__